import React, { useRef, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReactToPrint from "react-to-print";
import ExpandedHandoverView from "./ExpandedHandoverView";
import { getNotes, getSiFcReportByStudentId } from "../services/APIClient";
import "./PrintClassResults.css";
import "./JiSiReportsOverview.css";

// const YEAR_RANGES = {
//   "25/26": { start: "2025-08-15", end: "2026-08-15" },
//   "24/25": { start: "2024-08-15", end: "2025-08-15" },
// };
//
// function getCurrentAcademicYear(date = new Date()) {
//   const currentTimestamp = date.getTime();
//   for (const [label, range] of Object.entries(YEAR_RANGES)) {
//     const start = new Date(range.start).getTime();
//     const end = new Date(range.end).getTime();
//     if (currentTimestamp >= start && currentTimestamp < end) {
//       return label;
//     }
//   }
//   return "Unknown Year";
// }

function PrintSiFcReports(props) {
  const {
    classDetails,
    classAssessments,
    gradeLevel,
    teachers,
    assessment,
    students,
    studentsReadingScore,
    showAtRiskOnly,
    onSortData,
    showSortedData,
  } = props;

  console.log("showSortedData", showSortedData);

  const componentRef = useRef();
  const [classNotes, setClassNotes] = useState([]);
  const [printKey, setPrintKey] = useState(0);
  const readyResolveRef = useRef(null);

  const fetchClassNotes = () => {
    if (classDetails?.id) {
      return getNotes("class", classDetails.id)
        .then((res) => setClassNotes(res.data || []))
        .catch(() => setClassNotes([]));
    }
    return Promise.resolve();
  };

  useEffect(() => {
    fetchClassNotes();
  }, [classDetails?.id]);

  const handleExpandedViewReady = () => {
    if (readyResolveRef.current) {
      readyResolveRef.current();
      readyResolveRef.current = null;
    }
  };

  const handleBeforeGetContent = () => {
    return new Promise((resolve) => {
      readyResolveRef.current = resolve;
      setPrintKey((prev) => prev + 1);
      fetchClassNotes();
      setTimeout(() => {
        if (readyResolveRef.current) {
          readyResolveRef.current();
          readyResolveRef.current = null;
        }
      }, 5000);
    });
  };

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: landscape;
            }
          }
        `}
      </style>
      <SiFcReportPrintable
        ref={componentRef}
        classDetails={classDetails}
        gradeLevel={gradeLevel}
        teachers={teachers}
        assessment={assessment}
        students={students}
        studentsReadingScore={studentsReadingScore}
        showAtRiskOnly={showAtRiskOnly}
        onSortData={onSortData}
        showSortedData={showSortedData}
        classNotes={classNotes}
        printKey={printKey}
        onReady={handleExpandedViewReady}
      />
      <ReactToPrint
        content={() => componentRef.current}
        trigger={() => <button className="white-action-button">Print</button>}
        onBeforeGetContent={handleBeforeGetContent}
      />
    </>
  );
}

const SiFcReportPrintable = React.forwardRef((props, ref) => {
  const { classNotes } = props;
  // const academicYear = getCurrentAcademicYear();

  const formatNoteDate = (dateStr) => {
    return new Date(dateStr).toLocaleString("en-IE", {
      day: "numeric", month: "short", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Europe/Dublin",
    });
  };

  const getTeacherName = (teacherId) => {
    const teacher = props.teachers?.find((t) => t.id === teacherId);
    return teacher?.name || "Unknown";
  };

  const formatNoteType = (noteType) => {
    return noteType === "SiFcReport" || noteType === "SIFCReport"
      ? "ClassroomHandover"
      : noteType;
  };

  return (
    <div className="jisi-hide-div jisi-landscape-print" ref={ref}>
      {/* Print-only header
      <div className="alpaca-print-header">
        <div className="printout-logo" />
        <div className="alpaca-print-header-text">
          <span className="alpaca-print-header-class">
            {props.classDetails?.name || "Class Name"}
          </span>
          <span className="alpaca-print-header-year">
            School Year: {academicYear}
          </span>
        </div>
      </div>
      */}
      <Row className="mt-5 text-center">
        <Col className="printout-logo col-2"></Col>
        <Col className="col-4">
          <h3 className="printout-page-description-header">
            {props.classDetails.name}
          </h3>
        </Col>
        <Col className="col-4">
          <h3 className="printout-page-description-header">
            {props.assessment.name}
          </h3>
        </Col>
        <Col className="col-2">
          <h3 className="printout-page-description-header">
            {new Date().toLocaleString("default", { month: "long" })}{" "}
            {new Date().getFullYear()}
          </h3>
        </Col>
      </Row>
      {classNotes.length > 0 && (
        <Row className="mx-3 mb-3">
          <Col>
            <h4 style={{ color: "#333", marginTop: 0, marginBottom: "12px" }}> Class Notes </h4>

            {classNotes.map((note, idx) => (
              <div key={idx} style={{marginBottom: "10px", padding: "8px 12px", borderLeft: "3px solid #1a56db", background: "#f8f9fa", borderRadius: "4px"}}>
                
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "left", marginBottom: "4px"}}>
                  
                  {/* <span style={{ fontSize: "11px", fontWeight: "bold", background: "#1a56db", color: "white", padding: "2px 8px", borderRadius: "4px"}}>
                    {formatNoteType(note.note_type)}
                  </span> */}

                  <span style={{ fontSize: "11px", color: "#666" }}>
                    {getTeacherName(note.teacherid)} &bull; {formatNoteDate(note.date_created)}
                  </span>
                </div>

                <div style={{fontSize: "13px", color: "#333", whiteSpace: "pre-wrap"}}>
                  {note.note_text}
                </div>
              </div>
            ))}
          </Col>
        </Row>
      )}

      <Row>
        <ExpandedHandoverView
          key={props.printKey}
          students={props.students}
          classid={props.classDetails.id}
          teachers={props.teachers}
          studentsReadingScore={props.studentsReadingScore}
          showSortedData={props.showSortedData}
          showAtRiskOnly={props.showAtRiskOnly}
          onSortData={props.onSortData}
          getReport={getSiFcReportByStudentId}
          onReady={props.onReady}
        />
      </Row>
      {/* <div
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          textAlign: "center",
          fontSize: "0.9rem",
          color: "#888",
          padding: "8px 0",
          background: "white",
          zIndex: 1000,
        }}
      >
        Powered by ALPACA &copy; {new Date().getFullYear()}
      </div> */}
    </div>
  );
});

export default PrintSiFcReports;